export default "__VITE_ASSET__CyhJisza__"